export const i18n = {
    scorePoints: 'Bodů celkem',
    completedQuizzes: 'Dokončených kvízů',
    correctAnswers: 'Správných odpovědí',
    competitionRank: 'Pořadí',

    noScoresAvailable: 'Zatím není nic k hodnocení',

    quizzes: 'Kvízy',
    noQuizzesAvailable: 'Momentálně pro tebe nemáme žádný kvíz...',

    team: 'Ročník/třída',
    notATeamMember: 'Nejsi členem žádné třídy/ročníku!',
    teams: 'Členství v třídách/ročnících',
    joinTeam: 'Připojit se k ročníku/třídě',
    leaveTeam: 'Opustit',
    accessCode: 'Kód ročníku/třídy',
    failedToLeaveTeam: 'Nepodařilo se opustit tým',
    failedToJoinTeamWithCode: 'Nepodařilo se připojit k týmu s kódem',

    profileIncomplete: 'Tvůj profil není kompletní',
    completeProfile: 'Doplnit profil',
    emailNotVerified: 'Email není ověřený, zkontroluj si inbox a klikni na ověřovací odkaz',
    refreshVerificationState: "Zkontrolovat",

    exoUserLoadingFailed: 'Chyba při načítání uživatelských dat',

    termsAndConditions: 'Podmínky užívání',
    competitionRules: 'Pravidla soutěže',
    privacyPolicy: 'Ochrana osobnich údajů',
    contactCez: 'Kontaktuj ČEZ',

    loadingError: 'Chyba při načítání dat',
    required: 'Povinné',
    logout: 'Odhlásit',

    loadImage: 'Nahrát obrázek',
    account: 'Účet',
    email: 'Email',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    nickname: 'Přezdívka',
    save: 'Uložit',
    error: 'Chyba',
    failedToSaveChanges: 'Nepodařilo se uložit změny!',
    notFound: 'Nenalezeno',
    scoreboard: 'Průběžné výsledky',
    teacherScoreBoard: 'Průběžné výsledky pro učitele',

    state: 'Stav',
    deadline: 'Uzávěrka',
    totalTime: 'Celkový čas',
    achievedPoints: 'Získáno bodů',

    runQuiz: 'Spustit kvíz',
    browseQuiz: 'Prohlížet kvíz',

    checkAnswer: 'Zkontrolovat odpověď',
    nextQuestion: 'Další otázka',
    correct: 'Správně!',
    incorrect: 'Chybička',

    school: 'Škola',
    competition: 'Soutěž',

    enums: {
        quizState: {
            new: 'Nový',
            inProgress: 'Rozpracovný',
            completed: 'Dokončený',
            expired: 'Expirovaný',
            unknown: 'Neznámý',
        }
    },
}
